import getReportsStore from ".";
import { apiCallBanReport } from "../../api/report-api/api-call-handle-report";
import { TCorePage, TStatusExtraData } from "../../Types";
import getCorePopUpStore from "../core/core-popup-store";
import getCoreUIStore from "../core/core-ui-store";

const banReportOnDatabase = async (
  reportId: number,
  reportedId: number,
  reportedUUID: string,
  type: string,
  extraData: TStatusExtraData,
  pageName: TCorePage
) => {
  getCoreUIStore().setIsLoading("REPORTS", true);
  const { status, data, code } = await apiCallBanReport({
    reportId,
    reportedUUID,
    type,
    extraData,
    pageName
  });

  getCoreUIStore().setIsLoading("REPORTS", false);
  if (status === "OK") {
    getCorePopUpStore().showSuccessMessage(data);
    getReportsStore().removeBannedFromPendingReports({ reportedId });
    getReportsStore().decreaseDashboardReportsCount();
    getReportsStore().decreaseDashboardReportedCount(reportedId);
  } else {
    getCorePopUpStore().showAlertMessage(code);
  }
  return status;
};

export default banReportOnDatabase;
